module.exports = __webpack_public_path__ + "static/one-e760e35955bc1ec48070b069def990f4.png";